import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import AOS from "aos";
import "aos/dist/aos.css";
import { NavLink, useLocation } from "react-router-dom";
import { Button } from "@mui/material";

interface OurStoryProps {
  our: string;
  title: string;
  content: string;
  image: string;
  showReadMore?: boolean;
}

const OurStory: React.FC<OurStoryProps> = ({
  our,
  title,
  content,
  image,
  showReadMore = true,
}) => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
    });
  }, []);
  const { t } = useTranslation("home");
  const location = useLocation();
  const language = location.pathname.split("/")[1];
  
  return (
    <div className="!flex relative bg-white px-8 lg:px-20 py-28 items-center justify-center">
      <div
        className="flex flex-col lg:flex-row items-center lg:items-start"
        data-aos="fade-up"
      >
        <div className="flex flex-col justify-center lg:w-1/2 text-left text-text lg:pr-12 mb-16 lg:mb-0 self-center">
          <p className="font-medium text-customRed mb-1 uppercase">{our}</p>
          <h2 className="text-3xl font-medium mb-8 text-left uppercase ">
            {title}
          </h2>
          <p className="text-lg mb-8">{content}</p>
          
          <div className="mt-4">
            <NavLink
              to={`/${language}/contact`}
              onClick={() => {
                window.scrollTo({
                  top: 0,
                });
              }}
            >
              <Button
                variant="contained"
                sx={{
                  backgroundColor: "main",
                  ":hover": { backgroundColor: "darkred" },
                  py: 1.5,
                  px: 5,
                  borderRadius: "5px",
                  fontSize: "1.2rem",
                  textTransform: "none",
                }}
              >
                {t("become")}
              </Button>
            </NavLink>
          </div>
        </div>

        <div className="relative flex items-center justify-end content-start lg:w-1/2 self-center">
          <div className="relative z-10 lg:size-5/6 size-full">
            <div className="absolute border border-customRed rounded-md w-full h-full pointer-events-none right-6 top-6 -z-10"></div>
            <img
              src={image}
              alt="4 People in a meeting"
              className="object-cover rounded-md z-50"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default OurStory;
